/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { isPointerEventInsideRoot } from '@trimble/solidjs-utils';
import {
  Component,
  createSignal,
  onCleanup,
  onMount,
  Show,
  untrack,
} from 'solid-js';
import DropdownOptions from '../DropdownOptions/DropdownOptions';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import Icon from '../Icon/Icon';

export interface DropDownOption {
  text?: string;
  icon?: string;
  hasSubMenu?: boolean;
}

export interface DropDownMenuProps {
  /** The classname for dropdown menu. */
  className?: string;
  type?: 'icon' | 'link' | 'button' | 'selector';
  anchorText?: string;
  /** The anchor's icon. */
  anchorIcon?: string;
  /** The custom anchor's icon. */
  customAnchorIcon?: string;
  /** The custom anchor's class overrides. */
  customAnchorClassName?: string;
  /** The anchor's style. */
  anchorStyle?: string;
  /** The anchor's class overrides. */
  anchorClassName?: string;
  anchorIconShape?: 'icon-square' | 'icon-circle';
  /** The type of Dropdown options */
  anchorIconPosition?: 'left' | 'right';
  /** Default is text */
  optionsType?: 'text' | 'icon' | 'both';
  /** The dropdown options */
  dropDownOptions: string[] | DropDownOption[];
  /** The dropdown options class overrides. */
  dropDownClassName?: string;
  /** The tooltip for component */
  iconTooltip?: string;
  /** The tooltip for the disabled options */
  disabledOptionsTooltipTitle?: string;
  disabledOptionsTooltipClassName?: string;
  size?: 'small' | 'medium';
  /** The alignment for dropdown content */
  position?:
    | 'left'
    | 'right'
    | 'top left'
    | 'top right'
    | 'middle'
    | 'top middle';
  /** The position of the icon incase options type is "both" and indicate on which side icon should be displayed */
  /** Default is left */
  iconPosition?: 'left' | 'right';
  /** Indicates when dropdownoptions should be shown when scrolling, default behaviour is hiding the options */
  showOnScroll?: boolean;
  /** Indicates whether DropDownMenu is disabled */
  disabled?: boolean;
  /** The default selected option */
  selected?: string | string[];
  /** Indicated whether fixed style needs to be given */
  useFixedStyle?: boolean;
  customPosition?: boolean;
  /** Custom CSS class for dropdown positioning */
  customPositionClass?: string;
  /** Custom inline styles for dropdown positioning */
  customPositionStyle?: string;
  setWidth?: string;
  unsetHeight?: boolean;
  addSeparators?: number[];
  addGroupTitles?: { [key: string]: string };
  disabledItem?: number[];
  fabButton?: boolean;
  dontCloseOnClick?: boolean;
  customMenuItemIcon?: string;
  tooltip?: string;
  dataCy?: string;
  isActionAllowed?: boolean;
  // Callback props for event handling
  onMenuOpen?(isOpen: boolean): void;
  onIconClick?(): void;
  onSelectionChanged?(selected: string, index: number): void;
}

const DropDownMenu: Component<DropDownMenuProps> = (props) => {
  const positionValue = untrack(() => props.position);
  const [isOpen, setIsOpen] = createSignal(false);
  const [position, setPosition] = createSignal(positionValue);
  const [menuDetailsStyle, setMenuDetailsStyle] = createSignal<any>({});
  const [showSubComp, _setShowSubComp] = createSignal(false);
  const [showMainMenuOfSubComp, setShowMainMenuOfSubComp] = createSignal(false);

  let dropDownRef: HTMLDivElement | undefined;
  let dropDownContentRef: HTMLDivElement | undefined;
  let dropDownButtonRef: HTMLButtonElement | undefined;

  const getClassNames = (...classes: (string | undefined | boolean)[]) => {
    return classes.filter(Boolean).join(' ');
  };

  const handleOutsideClick = (e: MouseEvent | TouchEvent) => {
    if (!dropDownRef) {
      return;
    }
    if (!isPointerEventInsideRoot(e, dropDownRef)) {
      setIsOpen(false);
      setShowMainMenuOfSubComp(false);
      onOpenStateChange();
    }
  };

  const handleScroll = () => {
    if (!props.showOnScroll) {
      setIsOpen(false);
      onOpenStateChange();
    }
  };

  const onOpenStateChange = () => {
    // Call callback if provided
    if (props.onMenuOpen) {
      props.onMenuOpen(isOpen());
    }
  };

  const handleStateChange = (event: MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();

    if (showSubComp() && showMainMenuOfSubComp()) {
      setIsOpen(true);
    } else {
      if (props.disabled !== true) {
        setIsOpen(!isOpen());
        onOpenStateChange();

        // Call icon click callback if provided
        if (props.onIconClick) {
          props.onIconClick();
        }

        if (props.useFixedStyle === true) {
          setFixedStyle(event);
        } else {
          updatePosition(event);
        }
      }
    }

    if (props.dontCloseOnClick) {
      setIsOpen(true);
    }
  };

  const setFixedStyle = (event: MouseEvent) => {
    if (!dropDownContentRef || !dropDownButtonRef || !dropDownRef) return;

    const minThreshold = 20;
    const iconHeight = dropDownRef.clientHeight / 2;
    let top = event.pageY + iconHeight;

    if (
      window.innerHeight - event.pageY <
      dropDownContentRef.offsetHeight + minThreshold
    ) {
      const dropDownBoxHeight = dropDownContentRef.offsetHeight + iconHeight;
      top = event.pageY - dropDownBoxHeight;
    }

    let left = event.pageX;
    if (props.position === 'right') {
      left = event.pageX - dropDownContentRef.offsetWidth;
    }

    if (props.customPosition) {
      left = dropDownButtonRef.getBoundingClientRect().left + 32;
      top = dropDownButtonRef.getBoundingClientRect().top - 5;
    }

    const menuDetailsStyle = {
      position: 'fixed',
      left: left.toString() + 'px',
      top: top.toString() + 'px',
      bottom: 'auto',
      right: 'auto',
    };

    if (props.customPosition) {
      delete (menuDetailsStyle as any).bottom;
      delete (menuDetailsStyle as any).right;
    }

    setMenuDetailsStyle(menuDetailsStyle);
  };

  const updatePosition = (event: MouseEvent) => {
    if (!dropDownContentRef) return;

    const minThreshold = 20;
    let newPosition = props.position;

    const contentHeight =
      (dropDownContentRef.firstElementChild as HTMLElement | null)
        ?.offsetHeight ?? 0;

    if (window.innerHeight - event.pageY < contentHeight + minThreshold) {
      switch (props.position) {
        case 'left':
          newPosition = 'top left';
          break;
        case 'right':
          newPosition = 'top right';
          break;
        case 'middle':
          newPosition = 'top middle';
          break;
      }
    }

    setPosition(newPosition);
  };

  // NOTE: helper functions removed if unused to satisfy noUnusedLocals

  onMount(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('touchstart', handleOutsideClick);
    document.addEventListener('scroll', handleScroll, true);
  });

  onCleanup(() => {
    document.removeEventListener('mousedown', handleOutsideClick);
    document.removeEventListener('touchstart', handleOutsideClick);
    document.removeEventListener('scroll', handleScroll, true);
  });

  const getIconClass = () =>
    props.size === 'small' ? 'icon-small' : 'icon-medium';

  const anchorButtonContent = () => (
    <>
      <Show when={props.anchorIcon && props.anchorIconPosition === 'left'}>
        <Icon
          icon={props.anchorIcon!}
          size={getIconClass()}
          class={props.anchorStyle}
        />
      </Show>
      <span class="text-ellipsis m-width-0">{props.anchorText}</span>
      <Show
        when={
          props.anchorIcon &&
          (!props.anchorIconPosition || props.anchorIconPosition === 'right')
        }
      >
        <Icon
          icon={props.anchorIcon!}
          size={getIconClass()}
          class={props.anchorStyle}
        />
      </Show>
    </>
  );

  return (
    <div
      ref={dropDownRef}
      onClick={handleStateChange}
      class={getClassNames(
        'dropdown-pane-container',
        'connect-dropdown-menu m-width-0',
        props.className,
        props.disabled && 'disabled'
      )}
    >
      {/* Icon/Button type dropdown */}
      <Show
        when={
          props.type !== 'button' &&
          props.type !== 'selector' &&
          props.anchorIcon
        }
      >
        <CustomTooltip
          text={
            (props.isActionAllowed
              ? props.disabledOptionsTooltipTitle
              : props.iconTooltip) || ''
          }
          position={'bottom' as any}
        >
          <button
            ref={dropDownButtonRef}
            class={getClassNames(
              'dropdownpane-link button',
              props.anchorClassName || 'tertiary ' + getIconClass(),
              props.anchorIconShape || 'icon-circle',
              isOpen() && 'active'
            )}
            data-cy={props.dataCy || 'ddMenuIcon'}
            disabled={props.isActionAllowed}
          >
            <Icon
              icon={props.anchorIcon!}
              size={getIconClass()}
              class={props.anchorStyle}
            />
          </button>
        </CustomTooltip>
      </Show>

      {/* Button type dropdown */}
      <Show when={props.type === 'button' && props.anchorClassName}>
        <CustomTooltip
          text={
            (props.isActionAllowed
              ? props.disabledOptionsTooltipTitle
              : props.anchorText) || ''
          }
          position={'bottom' as any}
        >
          <button
            type="button"
            class={getClassNames('w-auto', props.anchorClassName)}
            data-cy="DropDownMenuButton"
            disabled={props.isActionAllowed}
          >
            {anchorButtonContent()}
          </button>
        </CustomTooltip>
      </Show>

      {/* Link type dropdown */}
      <Show when={props.type === 'link' && props.anchorClassName}>
        <a class={getClassNames('button', props.anchorClassName)}>
          <span class="text-ellipsis m-width-0">{props.anchorText}</span>
        </a>
      </Show>

      {/* Selector type dropdown */}
      <Show when={props.type === 'selector'}>
        <button
          type="button"
          class={getClassNames(
            'toolbar-primary p-0.5 flex bg-base-page hover:bg-[var(--modus-wc-color-base-100)] rounded-sm',
            props.anchorClassName,
            getIconClass(),
            '!w-fit !ml-0'
          )}
          style={props.anchorStyle}
        >
          <Show
            when={props.anchorIcon !== undefined}
            fallback={
              <img
                class={getClassNames('', props.customAnchorClassName)}
                src={props.customAnchorIcon}
              />
            }
          >
            <div
              onClick={handleStateChange}
              class={getClassNames(
                isOpen() && 'active',
                getIconClass(),
                'flex flex-row items-center justify-center content-center'
              )}
            >
              <Icon
                icon={props.anchorIcon!}
                size={getIconClass()}
                class={getClassNames(props.anchorStyle, 'px-0.5 mx-0.5')}
              />
              <i
                class={`icon-font tc-icon-arrow-drop-down transition-all duration-300 !h-[24px] ${isOpen() ? 'rotate-180' : ''}`}
              />
            </div>
          </Show>
        </button>
      </Show>

      {/* Dropdown Options */}
      <Show when={isOpen()}>
        <div
          ref={dropDownContentRef}
          style={`${menuDetailsStyle()}${props.customPositionStyle ? `;${props.customPositionStyle}` : ''}`}
          class={props.customPositionClass}
        >
          <DropdownOptions
            isOpen={isOpen()}
            position={position()}
            iconPosition={props.iconPosition}
            optionsType={props.optionsType || 'text'}
            dropDownOptions={props.dropDownOptions}
            // eslint-disable-next-line solid/no-react-specific-props
            className={props.dropDownClassName}
            selected={props.selected}
            setWidth={props.setWidth}
            addSeparators={props.addSeparators}
            addGroupTitles={props.addGroupTitles}
            unsetHeight={props.unsetHeight}
            customMenuItemIcon={props.customMenuItemIcon}
            disabledItem={props.disabledItem}
            tooltipTitle={props.disabledOptionsTooltipTitle}
            tooltipClassName={props.disabledOptionsTooltipClassName}
            customPositionClass={props.customPositionClass}
            fabButton={props.fabButton}
            onSelectionChanged={(selected, index) => {
              // Close dropdown when item is selected (unless dontCloseOnClick is true)
              if (!props.dontCloseOnClick) {
                setIsOpen(false);
                onOpenStateChange();
              }

              // Call the parent callback
              if (props.onSelectionChanged) {
                props.onSelectionChanged(selected, index);
              }
            }}
          />
        </div>
      </Show>
    </div>
  );
};

export default DropDownMenu;
